export type SvgProps = React.SVGProps<SVGSVGElement>;

export function IconPortfolio(props: SvgProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={25}
            height={24}
            fill="none"
            {...props}
        >
            <path
                fill="currentColor"
                d="M16.79 3C20.066 3 22 4.885 22 8.113h-4.02v.033c-1.865 0-3.377 1.474-3.377 3.293 0 1.819 1.512 3.293 3.377 3.293H22v.296c0 3.187-1.934 5.072-5.21 5.072H8.21C4.934 20.1 3 18.215 3 15.028V8.072C3 4.885 4.934 3 8.21 3h8.58Zm4.5 6.529a.7.7 0 0 1 .71.691v2.404a.709.709 0 0 1-.71.692h-3.234c-.944.012-1.77-.618-1.984-1.515a1.883 1.883 0 0 1 .411-1.57 1.987 1.987 0 0 1 1.497-.702h3.31Zm-2.854 1.111h-.312a.727.727 0 0 0-.513.202.691.691 0 0 0-.213.498c0 .393.324.712.726.716h.312a.717.717 0 0 0 .727-.708.717.717 0 0 0-.727-.708Zm-5.573-3.943H7.501a.718.718 0 0 0-.726.7c0 .392.323.711.726.716h5.362a.717.717 0 0 0 .726-.708.717.717 0 0 0-.726-.708Z"
            />
        </svg>
    );
}
